export default function Header({ title, subtitle, children, className = '' }) {
  return (
    <div className={`flex flex-col mb-6 ${className}`}>
      <div className="flex flex-1 justify-between items-center">
        <div>
          <h1 style={{ margin: 0 }}>{title}</h1>
          {subtitle && <p style={{ margin: '8px 0 0 0', color: 'var(--color-text-secondary)' }}>{subtitle}</p>}
        </div>
        {children && <div className="flex gap-2">{children}</div>}
      </div>
    </div>
  );
}
